export enum SubscriptionPlan {
  TRIAL = 'Trial', SOLO = 'Solo', ENTERPRISE = 'Enterprise'
}